import { Card, Heading, Button, Pane, Checkbox, majorScale } from 'evergreen-ui';
import { EditIcon, RemoveIcon, DocumentIcon } from 'evergreen-ui';

export const formatDate = (dateString) => (dateString ? new Date(dateString).toLocaleString() : 'N/A');

// Gli allegati arrivano già puliti da parseAttachments (niente voci vuote).
const AttachmentLinks = ({ attachments }) => {
    if (!Array.isArray(attachments) || attachments.length === 0) return null;
    return (
        <Pane marginTop={16}>
            <Heading size={400} marginBottom={8}>Allegati:</Heading>
            <ul style={{ paddingLeft: 16 }}>
                {attachments.map((attachment) => (
                    <li key={attachment.url}>
                        <a href={attachment.url} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                            <DocumentIcon flexShrink={0} /> {attachment.name}
                        </a>
                    </li>
                ))}
            </ul>
        </Pane>
    );
};

const ViewersList = ({ item, views, viewKey, viewerDetails, noViewsLabel }) => {
    // Prima le views di questo elemento, poi il controllo "vuoto": altrimenti, se altri
    // elementi hanno views, la lista restava vuota senza il messaggio.
    const itemViews = (views || []).filter((view) => view[viewKey] === item.id);
    return (
        <Pane marginTop={majorScale(2)}>
            <Heading size={400}>Visualizzato da:</Heading>
            <ul>
                {itemViews.length > 0 ? itemViews.map((view) => (
                    <li key={`${view[viewKey]}-${view.user_id}`}>
                        {viewerDetails[view.user_id]?.nome || 'Nome non disponibile'} {viewerDetails[view.user_id]?.cognome || ''}
                        {view.viewed_at ? ` - ${formatDate(view.viewed_at)}` : ''}
                    </li>
                )) : (
                    <li>{noViewsLabel}</li>
                )}
            </ul>
        </Pane>
    );
};

const ReadCheckbox = ({ isRead, onMarkAsRead }) => (
    <Pane marginTop={majorScale(2)}>
        <Checkbox label={isRead ? 'Letto' : 'Segna come letto'} checked={isRead} disabled={isRead} onChange={onMarkAsRead} />
    </Pane>
);

const DirectorActions = ({ onEdit, onRemove }) => (
    <Pane className="card-actions" display="flex" gap={8} marginTop={majorScale(2)}>
        <Button appearance="primary" intent="success" onClick={onEdit}>
            Modifica <EditIcon marginLeft={8} />
        </Button>
        <Button intent="danger" onClick={onRemove}>
            Rimuovi <RemoveIcon marginLeft={8} />
        </Button>
    </Pane>
);

const CardHeader = ({ item, onToggle }) => (
    <Pane className="card-header">
        <Heading size={500} onClick={onToggle} style={{ cursor: 'pointer' }}>
            {item.title}
        </Heading>
        <Pane>
            <div className="date-line">Creato: {formatDate(item.timestamp)}</div>
            {item.last_modified && <div className="date-line">Modificato: {formatDate(item.last_modified)}</div>}
        </Pane>
    </Pane>
);

// ctx: dati e azioni comuni a tutte le card, preparati da BoardList.
const BoardListCard = ({ item, isOpen, ctx }) => {
    const { userRole, views, viewKey, viewerDetails, labels, readIds } = ctx;
    const isDirector = userRole === 'direttore';
    const isReader = userRole === 'operatore' || userRole === 'educatore';
    return (
        <Card className="card-flex" elevation={1} padding={16} marginBottom={8}>
            <CardHeader item={item} onToggle={() => ctx.onToggle(item)} />
            {isOpen && (
                <>
                    <Pane className="card-body" marginTop={16}>
                        <p>{item.body}</p>
                        <AttachmentLinks attachments={item.attachments} />
                        {isDirector && <ViewersList item={item} views={views} viewKey={viewKey} viewerDetails={viewerDetails} noViewsLabel={labels.noViews} />}
                        {isReader && <ReadCheckbox isRead={readIds.has(item.id)} onMarkAsRead={() => ctx.onMarkAsRead(item.id)} />}
                    </Pane>
                    {isDirector && <DirectorActions onEdit={() => ctx.onEdit(item.id)} onRemove={() => ctx.onRemove(item)} />}
                </>
            )}
        </Card>
    );
};

export default BoardListCard;
